import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA4, sendGA4PageView } from "../../Utils/ga4";

export default function Ga4Tracker() {
  const location = useLocation();

  useEffect(() => {
    initGA4();
  }, []);

  useEffect(() => {
    sendGA4PageView(`${location.pathname}${location.search}`);
  }, [location]);

  return null;
}
